// extracted by mini-css-extract-plugin
export default {"styles":"mbiNotFound_styles__T3J5r"};